var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',{attrs:{"content-class":"mt-1"}},[_c('b-tab',{attrs:{"title":_vm.$t('Loading...')}},[_c('div',{staticClass:"card d-flex justify-content-center align-items-center",staticStyle:{"height":"150px"}},[_c('b-spinner',{attrs:{"variant":"primary"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }